export default function assertNever(value, message = "unexpected value") {
    console.error(message, value);
    throw new Error(message);
}
